// extracted by mini-css-extract-plugin
module.exports = {"heroTitle":"errorBase_heroTitle__ZKtLH","heroSubtitle":"errorBase_heroSubtitle__s5Nk_","appear":"errorBase_appear__Uhy1B","button":"errorBase_button___uhQq"};